export const FLUID_ERROR_CODES = {
  CONNECTION_FAILED: "connection-failed",
  MAX_RETRIES_EXCEEDED: "max-retries-exceeded",
  NO_TEAM: "no-team",
  RECREATION_FAILED: "recreation-failed",
  SCHEMA_INCOMPATIBLE: "schema-incompatible",
  UNKNOWN: "unknown",
} as const;

export type FluidErrorCode =
  (typeof FLUID_ERROR_CODES)[keyof typeof FLUID_ERROR_CODES];

export const FLUID_ERROR_MESSAGES: Record<FluidErrorCode, string> = {
  [FLUID_ERROR_CODES.NO_TEAM]: "Please select a team to enter the office",
  [FLUID_ERROR_CODES.SCHEMA_INCOMPATIBLE]:
    "The office structure was updated. Please try entering again.",
  [FLUID_ERROR_CODES.CONNECTION_FAILED]:
    "Failed to connect to the office. Please check your internet connection.",
  [FLUID_ERROR_CODES.RECREATION_FAILED]:
    "Failed to update the office structure. Please try again.",
  [FLUID_ERROR_CODES.MAX_RETRIES_EXCEEDED]:
    "Failed to connect to the office after multiple attempts. Please try again later.",
  [FLUID_ERROR_CODES.UNKNOWN]:
    "An unexpected error occurred. Please try again.",
};

export function getErrorMessage(code: string): string {
  return (
    FLUID_ERROR_MESSAGES[code as FluidErrorCode] ||
    FLUID_ERROR_MESSAGES[FLUID_ERROR_CODES.UNKNOWN]
  );
}
